import { useTranslation } from 'react-i18next';
import { TriangleAlert } from 'lucide-react';
import { useMaintenanceMode } from '@/shared/hooks/useMaintenanceMode';

/** Global banner shown when maintenance mode is active. */
export function MaintenanceBanner() {
  const { t } = useTranslation();
  const maintenance = useMaintenanceMode();

  if (!maintenance) return null;

  return (
    <div className="border-b border-amber-500/40 bg-amber-500/10 px-4 py-2.5 text-center text-sm font-medium text-amber-700 dark:text-amber-300">
      <span className="inline-flex items-center gap-1.5">
        <TriangleAlert className="h-4 w-4 shrink-0" />
        {t('maintenance.banner')}
      </span>
    </div>
  );
}
